/* Celebration Jewelers — Maison (v4). Site-wide behaviour, no dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('mx-js');

  var store = {};
  try { store = JSON.parse(document.getElementById('hm-store').textContent); } catch (e) {}

  /* ---------- Hours: live open/closed in Eastern time ------------------- */
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function parseRange(s) {
    if (!s) return null;
    var m = String(s).replace(/\s/g, '').match(/^(\d{1,2})(?::(\d{2}))?-(\d{1,2})(?::(\d{2}))?$/);
    if (!m) return null;
    return { open: +m[1] * 60 + (+m[2] || 0), close: +m[3] * 60 + (+m[4] || 0) };
  }
  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'pm' : 'am';
    h = h % 12 || 12;
    return h + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ap;
  }
  function easternNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var day = DAYS.indexOf(o.weekday.toLowerCase().slice(0, 3));
      return { day: day, mins: (+o.hour % 24) * 60 + +o.minute };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), mins: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function status() {
    var hours = store.hours || {};
    var now = easternNow();
    var today = parseRange(hours[DAYS[now.day]]);
    if (today && now.mins >= today.open && now.mins < today.close) {
      var left = today.close - now.mins;
      return { state: 'open', main: 'Open now', sub: left <= 60 ? 'Closes soon · ' + fmt(today.close) : 'Until ' + fmt(today.close), day: now.day };
    }
    if (today && now.mins < today.open) {
      return { state: 'closed', main: 'Opens today', sub: 'At ' + fmt(today.open), day: now.day };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7, r = parseRange(hours[DAYS[d]]);
      if (r) return { state: 'closed', main: 'Closed now', sub: 'Opens ' + (i === 1 ? 'tomorrow' : DAY_NAMES[d]) + ' ' + fmt(r.open), day: now.day };
    }
    return { state: 'unknown', main: 'Call for hours', sub: '', day: now.day };
  }
  function paintStatus() {
    var s = status();
    document.querySelectorAll('[data-hm-status]').forEach(function (el) {
      var changed = el.getAttribute('data-state') !== s.state;
      el.setAttribute('data-state', s.state);
      var main = el.querySelector('[data-hm-status-main]'), sub = el.querySelector('[data-hm-status-sub]');
      if (main) main.textContent = s.main;
      if (sub) sub.textContent = s.sub;
      if (changed && el.classList.contains('is-struck')) { el.classList.remove('is-struck'); void el.offsetWidth; el.classList.add('is-struck'); }
    });
    document.querySelectorAll('[data-hm-hours-row]').forEach(function (row) {
      row.classList.toggle('is-today', +row.getAttribute('data-hm-hours-row') === s.day);
    });
  }
  paintStatus();
  setInterval(paintStatus, 60000);

  /* ---------- Reveal on scroll ------------------------------------------ */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-rise]:not(.is-in), [data-fade]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  reveal();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); paintStatus(); });
  /* Safety: never leave content hidden if an observer misfires. */
  setTimeout(function () { document.querySelectorAll('[data-rise], [data-fade]').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in'); }); }, 2500);

  /* ---------- Header: scrolled state ------------------------------------ */
  var header = document.querySelector('.mx-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawer + search ------------------------------------------- */
  function bindToggle(openSel, panel, focusSel) {
    if (!panel) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      panel.classList.add('is-open');
      panel.removeAttribute('inert');
      document.querySelectorAll(openSel).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var f = panel.querySelector(focusSel || 'a, button, input');
      if (f) setTimeout(function () { f.focus(); }, 60);
      if (panel.classList.contains('mx-drawer')) document.body.style.overflow = 'hidden';
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('inert', '');
      document.querySelectorAll(openSel).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    document.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); panel.classList.contains('is-open') ? close() : open(); }); });
    panel.querySelectorAll('[data-hm-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
  }
  bindToggle('[data-hm-open-drawer]', document.getElementById('mx-drawer'));
  bindToggle('[data-hm-open-search]', document.getElementById('mx-search'), 'input[type="search"]');

  /* ---------- Horizontal cases: arrow buttons --------------------------- */
  document.querySelectorAll('[data-hm-case]').forEach(function (wrap) {
    var track = wrap.querySelector('.mx-rail');
    if (!track) return;
    wrap.querySelectorAll('[data-hm-case-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = +b.getAttribute('data-hm-case-step');
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  });

  /* ---------- Conversion tracking: calls, directions, texts ------------- */
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
        if (name === 'click_to_call' && store.adsCall) window.gtag('event', 'conversion', { send_to: store.adsCall });
      }
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, params || {});
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var where = a.getAttribute('data-hm-where') || (a.closest('[id^="shopify-section-"]') || {}).id || 'page';
    if (href.indexOf('tel:') === 0) track('click_to_call', { where: where });
    else if (href.indexOf('sms:') === 0) track('click_to_text', { where: where });
    else if (/google\.[a-z.]+\/maps|maps\.apple|maps\.google/.test(href)) track('get_directions', { where: where });
  });

  /* ---------- Mobile action bar hides near the footer ------------------- */
  var bar = document.querySelector('.mx-actionbar'), foot = document.querySelector('.mx-footer__base');
  if (bar && foot && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { bar.classList.toggle('is-hidden', en[0].isIntersecting); }).observe(foot);
  }

  window.MX = window.HM = { reveal: reveal, status: status, track: track };
})();
